<template>
  <nav class="partial-header navbar navbar-default navbar-fixed-top" v-if="user">
    <div class="container-fluid">
      <button class="hidden-md hidden-lg btn btn-sm btn-default pull-right" style="margin-top: 9px;" @click="toggleDrawer()">
        <i class="fa fa-bars"></i>
      </button>
      <div class="navbar-header">
        <router-link :to="{name: 'home'}" class="navbar-brand">
          <img :src="imageUrl('ls.png', '50x50')" alt="Loca.Shop" class="ls">
          <img v-if="user.company && user.company.image" :src="user.company.image" :alt="user.company.fantasy_name">
        </router-link>
      </div>
      <div class="hidden-xs hidden-sm">
        <ul class="nav navbar-nav">
          <template v-if="user.company.status">
            <li :class="{ 'active' : routeName.startsWith('home')}" class="dropdown">
              <router-link :to="{name: 'home'}" title="Home"> <i class="fa fa-fw fa-lg fa-home"></i></router-link>
            </li>
            <registrations-menu></registrations-menu>
            <li :class="{ 'active': routeName.startsWith('mktp_')}" class="dropdown">
              <router-link :to="{name: 'mktp_home'}" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                Pedidos<span v-if="notificationsPanel && notificationsPanel.mktp_rents > 0" class="bell-badge">{{ notificationsPanel.mktp_rents }}</span>
              </router-link>
            </li>
            <li :class="{ 'active': routeName.startsWith('products_')}" class="dropdown">
              <router-link :to="{name: 'products_list'}">Produtos</router-link>
            </li>
            <li v-if="[1].includes(user.company.id)" :class="{ 'active': routeName.startsWith('rents_')}" class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Locações <span class="caret"></span></a>
              <ul class="dropdown-menu">
                <li><router-link :to="{name: 'rents_add'}"><i class="fa fa-fw fa-btn fa-plus"></i> Cadastrar</router-link></li>
                <li><router-link :to="{name: 'rents_list'}"><i class="fa fa-fw fa-btn fa-search"></i> Pesquisar</router-link></li>
                <li><router-link :to="{name: 'rents_dashboard', params: { statusId: 1 }}"><i class="fa fa-fw fa-btn fa-bell"></i> Painel operacional</router-link></li>
              </ul>
            </li>
            <rent-pre-registrations-menu v-if="[2,3,6,182].includes(user.company.id)"></rent-pre-registrations-menu>
            <general-notifications></general-notifications>
            <!--
            <li :class="{ 'active': routeName.startsWith('shopping_')}" class="dropdown">
              <router-link :to="{name: 'shopping_catalog'}">Shopping</router-link>
            </li>
            -->
            <chat-menu v-if="[2,3,6,182].includes(user.company.id)"></chat-menu>
            <clients-photos-menu></clients-photos-menu>
          </template>
          <!--
          <li><router-link :to="{name: 'finances_invoices'}"><i class="fa fa-fw fa-btn fa-search"></i> Pesquisar faturas</router-link></li>
          <li><router-link :to="{name: 'finances_accounts'}"><i class="fa fa-fw fa-btn fa-bank"></i> Contas bancárias</router-link></li>
          <li><router-link :to="{name: 'finances_dashboard'}"><i class="fa fa-fw fa-btn fa-dashboard"></i> Dashboard</router-link></li>
          -->
        </ul>
        <ul class="nav navbar-nav navbar-right">
          <!-- <quantity-rents-menu v-if="user"></quantity-rents-menu> -->
          <router-link v-if="user.company.status" class="btn btn-sm btn-success navbar-btn pull-left" :to="{name: 'clients_add', params: { statusId: 1, modalVideo: true }}"><i class="fa fa-plus"></i> Novo cadastro</router-link>
          <li>&nbsp;&nbsp;</li>
          <router-link v-if="isCompanyAdmin()" class="btn btn-sm btn-info navbar-btn pull-left" :to="{name: 'finances_dashboard', query: { buy_credit: 1}}">Comprar crédito</router-link>
          <li>&nbsp;&nbsp;</li>
          <li class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i class="fa fa-fw fa-bars"></i></a>
            <ul class="dropdown-menu">
              <li class="dropdown-header"><i class="fa fa-fw fa-btn fa-user"></i>{{ user.name }}</li>
              <li role="separator" class="divider"></li>
              <li v-if="isCompanyAdmin()"><router-link :to="{name: 'company_details'}"><i class="fa fa-fw fa-btn fa-building"></i> Locadora</router-link></li>
              <li v-if="isCompanyAdmin()"><router-link :to="{name: 'employees'}"><i class="fa fa-fw fa-btn fa-users"></i> Usuários</router-link></li>
              <li v-if="isCompanyAdmin()"><router-link :to="{name: 'shipping'}"><i class="fa fa-fw fa-btn fa-truck"></i> Configurações de Frete</router-link></li>
              <li v-if="isCompanyAdmin()"><router-link :to="{name: 'finances_dashboard'}"><i class="fa fa-fw fa-btn fa-dollar"></i> Financeiro</router-link></li>
              <li role="separator" class="divider"></li>
              <li><a :href="locashopURL + 'termos-de-uso'" target="_blank"> <i class="fa fa-fw fa-btn fa-address-book"></i> Termos de uso </a></li>
              <li><a :href="locashopURL + 'politicas-de-privacidade'" target="_blank"> <i class="fa fa-fw fa-btn fa-id-badge"></i> Política de privacidade </a></li>
              <!--
              <li v-if="isCompanyAdmin()"><router-link :to="{name: 'plans'}"><i class="fa fa-fw fa-btn fa-list-ul"></i> Planos</router-link></li>
              <li><router-link :to="{name: 'mailing'}"><i class="fa fa-fw fa-btn fa-envelope"></i> E-mails marketing</router-link></li>
              <li><router-link :to="{name: 'help'}"><i class="fa fa-fw fa-btn fa-life-saver"></i> Ajuda</router-link></li>
              -->
              <li role="separator" class="divider"></li>
              <li><a v-on:click="handleLogout()"><i class="fa fa-fw fa-btn fa-sign-out"></i> Sair</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  import * as config from '../../config.js'
  import {mapState, mapActions} from 'vuex'
  import MktpMenu from '../../components/app/MktpMenu'
  import GeneralNotifications from '../../components/app/itens_menu/GeneralNotifications.vue'
  import RegistrationsMenu from '../../components/app/itens_menu/RegistrationsMenu.vue'
  // TODO: Resolver o problema do menu superior (está quebrando no XS, SM e MD)

  export default{
    name: 'PartialDrawerNavigation',
    components: { MktpMenu, GeneralNotifications, RegistrationsMenu },
    data () {
      return {
        locashopURL: config.locashopURL
      }
    },
    computed: {
      routeName () {
        return this.$route.name || ''
      },
      apiDomain () {
        return config.apiDomain
      },
      ...mapState({
        notificationsPanel: state => state.notificationsPanel,
        recentClients: state => state.recentClients,
        user: state => state.user
      })
    },
    mounted () {
      window.$('.dropdown', this.$el).click((e) => {
        e.stopPropagation()
      })
    },
    methods: {
      handleLogout () {
        this.unsubscribeChannel()
        this.unsetUser()
        this.$router.push({name: 'login'})
      },
      toggleDrawer () {
        this.$emit('toggle-drawer', true)
      },
      ...mapActions(['unsetUser'])
    }
  }
</script>



// WEBPACK FOOTER //
// PartialHeader.vue?2af66d62